// src/ExpertHome.jsx

import React, { useState } from 'react';
import { useAuth } from '../lib/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardContent } from '../components/ui/card';
import AvailabilityModal from '../common/AvailabilityModal';

const ExpertHome = () => {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

const handleAvailabilitySubmit = async ({ start_time, end_time }) => {
  try {
    const token = localStorage.getItem("access");
    const res = await fetch("https://quirkleai.com/api/availability/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({ start_time, end_time })
    });

    if (!res.ok) throw new Error("Failed to save availability");

    alert("✅ Availability saved!");
    setShowModal(false);  // close modal on success
  } catch (err) {
    alert("❌ Error: " + err.message);
  }
};


  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">Hi, {user?.username}</h1>

      <Card className="rounded-lg shadow-sm border">
        <CardHeader>
          <h2 className="text-lg font-bold text-gray-800">🎯 Make the page yours!</h2>
          <p className="text-sm text-gray-500">Unlock the potential of your expert profile</p>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button className="w-full justify-start gap-2" onClick={() => setShowModal(true)}>➕ Add availability</Button>
          <Button className="w-full justify-start gap-2">📝 Complete your profile</Button>
          <Button className="w-full justify-start gap-2">⚙ Create a service</Button>
        </CardContent>
      </Card>

      <div className="text-gray-700 mt-8">
        <h3 className="text-sm font-semibold mb-2">Need some help?</h3>
        <div className="flex flex-wrap gap-4">
          <Button variant="outline" className="flex items-center gap-2">📞 Contact Support</Button>
          <Button variant="outline" className="flex items-center gap-2">📚 How it Works</Button>
          <Button variant="outline" className="flex items-center gap-2">🤝 Referral Help</Button>
        </div>
      </div>

      <AvailabilityModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleAvailabilitySubmit}
      />
    </div>
  );
};

export default ExpertHome;
